var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-dialog",
        {
          attrs: {
            "md-close-on-esc": false,
            "md-click-outside-to-close": false,
            "md-active": _vm.isSettingsOpened
          },
          on: {
            "update:mdActive": function($event) {
              _vm.isSettingsOpened = $event
            },
            "update:md-active": function($event) {
              _vm.isSettingsOpened = $event
            }
          }
        },
        [
          _c("md-dialog-title", [_vm._v(_vm._s(_vm.i18n.set_tfa_enable()))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "app__dialog-inner" },
            [
              _c("p", { staticClass: "tfa-settings__explain" }, [
                _vm._v(_vm._s(_vm.i18n.set_tfa_scan_the_qr_code()))
              ]),
              _vm._v(" "),
              _vm.inputMode === _vm.INPUT_MODES.qr
                ? _c(
                    "div",
                    { staticClass: "tfa-settings__qr-outer" },
                    [
                      _c("qrcode", {
                        staticClass: "tfa-settings__qr-code",
                        attrs: {
                          text: _vm.factor.qr,
                          size: 225,
                          color: "#3f4244"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "tfa-settings__explain-additional" }, [
                _vm._v(_vm._s(_vm.i18n.set_or_manually_enter()))
              ]),
              _vm._v(" "),
              _c("clipboard-field", {
                staticClass: "tfa-settings__copy-secret",
                attrs: {
                  value: _vm.factor.secret,
                  label: _vm.i18n.lbl_secret()
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            { staticClass: "md-layout md-alignment-center-right" },
            [
              _c(
                "md-button",
                { staticClass: "md-primary", on: { click: _vm.updateFactor } },
                [_vm._v(_vm._s(_vm.i18n.lbl_confirm()))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30a9dc82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a9dc82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/auth/TwoFA.vue
// module id = tjZm
// module chunks = 1